import type { I18nFn } from '#/i18n/types/I18nFn';

export function LISTING_TYPE_HUMAN_NAME_MAP_SEARCH(i18n: I18nFn) {
  return {
    ALL: i18n('Everything'),
    JOB: i18n('Jobs'),
    INTERNSHIP: i18n('Internships'),
    VOLOP: i18n('Volunteer Opportunities'),
    EVENT: i18n('Events'),
    ORG: i18n('Organizations'),
    GROUP: i18n('Groups'),
    USER: i18n('Users'),
    INVOICE: i18n('Invoices'),
    PAYMENT: i18n('Payments'),
    DONATION: i18n('Donations'),
    CMS_PAGE: i18n('Articles'),
  };
}
